<template>
  <li class="numer_list_item">
    <div>
      <p>{{ index }}</p>
      <div />
    </div>
    <div>
      <slot></slot>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped>
.numer_list_item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
.numer_list_item:not(:last-of-type) {
  margin-bottom: 16px;
}

.numer_list_item:last-of-type > div:first-of-type > div {
  display: none;
}

.numer_list_item:last-of-type > div:first-of-type > p {
  background-color: var(--primary-color-1);
  color: var(--gray-scale-12);
  font-weight: 700;
}

.numer_list_item > div:first-of-type {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  height: 100%;
}

.numer_list_item > div:first-of-type > p {
  color: var(--gray-scale-2);
  border-radius: 8px;
  background-color: var(--gray-scale-7);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}
.numer_list_item > div:first-of-type > div {
  width: 3px;
  height: 84px;
  border-radius: 100px;
  background-color: var(--gray-scale-7);
}
.numer_list_item > div:last-of-type {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiNumberListItem.vue